module.exports = __webpack_public_path__ + "static/media/ic_youtube.4558986a.svg";